module.exports = {"511425001":"青竹街道","511425102":"汉阳镇","511425108":"瑞峰镇","511425110":"西龙镇","511425112":"高台镇","511425217":"白果乡","511425218":"罗波乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511425.json
// module id = 2485
// module chunks = 0